import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthGovService } from '../auth/auth-gov.service';
import { catchError, finalize, map, Observable, of } from 'rxjs';
import { AuthStateService } from '../auth/auth-state-service';
import { TokenService } from '../services/tokenservice/token.service';
import { LoadingService } from '../services/loadingservice/loading.service';

export const govGuardServiceFunction: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const govGuardService = inject(GovGuardService)
  return govGuardService.canActivate(route, state)
}

@Injectable({
  providedIn: 'root'
})
export class GovGuardService  {


  constructor(
    private authGovService: AuthGovService,
    private router: Router,
    private authStateService: AuthStateService,
    private tokenService: TokenService,
    private loadingService: LoadingService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    const code = route.queryParams['code'];
    const stateParam = route.queryParams['state'];

    if (this.tokenService.hasValidToken()) {
      return of(true);
    }

    if (this.authStateService.getAuthMethod() === 'gov' && code && stateParam) {
      this.loadingService.show();

      return this.authGovService.handleCallback(route.queryParams).pipe(
        map((response) => {
          let responseToken = JSON.parse(response).tokenGovBr;
          if (response && responseToken) {
            this.tokenService.setToken(responseToken);
            this.router.navigate(['/auth'])
            return true;
          }
          return false;
        }),
        catchError((error) => {
          console.error('Erro ao obter o token:', error);
          return of(false);
        }),
        finalize(() => {
          this.loadingService.hide();
        })
      );
    } else if (this.authStateService.getAuthMethod() === 'ping') {
      return of(true)
    } else {
      this.router.navigate(['/home'])
      return of(false);
    }
  }
}
